export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9025.047f6ea7.jpg";